/**
 * @generated SignedSource<<1bb18097bf6d7dbf1646e636a3bd0f45>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterDeliveryOptions_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuShippingFiltersWrapper_user">;
  readonly " $fragmentType": "SbSharedRefineMenuFilterDeliveryOptions_user";
};
export type SbSharedRefineMenuFilterDeliveryOptions_user$key = {
  readonly " $data"?: SbSharedRefineMenuFilterDeliveryOptions_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilterDeliveryOptions_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterDeliveryOptions_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuShippingFiltersWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d121e01bcd9bffe7a5aa1c48a879be6d";

export default node;
